import { render, staticRenderFns } from "./contractApplyAuditOrdersList.vue?vue&type=template&id=b637caba&scoped=true"
import script from "./contractApplyAuditOrdersList.vue?vue&type=script&lang=js"
export * from "./contractApplyAuditOrdersList.vue?vue&type=script&lang=js"
import style0 from "./contractApplyAuditOrdersList.vue?vue&type=style&index=0&id=b637caba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b637caba",
  null
  
)

export default component.exports